export const BETA_FEATURE_CUSTOM_LOGO = 'react_header_icon_override';
export const BETA_FEATURE_MODEL_PRODUCTION_MONITORING_INTERNAL =
  'model-production-monitoring-internal';
export const BETA_FEATURE_MODEL_PRODUCTION_MONITORING_SLACK_CONNECTION =
  'model-production-monitoring-slack-connection';
export const BETA_FEATURE_MPM_DASHBOARD = 'mpm-dashboard';

export const BETA_FEATURE_SERVICE_ACCOUNTS = 'service-accounts';
export const BETA_FEATURES_DOWNLOAD_REPORTS =
  'admin-dashboard-download-reports';
export const BETA_FEATURE_REPORTS_NEW_DESIGN = 'reports-new-design';

export const BETA_SERVER_CUSTOM_PANELS = 'server-custom-panels';
export const BETA_PYTHON_ENVIRONMENT = 'python-environments';
export const BETA_FEATURE_LLM_EVAL = 'llm-eval';
export const BETA_FEATURE_INCREASE_SAMPLE_SIZE = 'increase-sample-size';
export const BETA_FEATURE_NEW_PAYMENT_PLANS = 'new-payment-plans';

export const BETA_FEATURE_HTML_TAB_ALLOW_SCRIPTS = 'html-tab-allow-scripts';
export const BETA_FEATURE_HTML_TAB_ALLOW_POPUPS = 'html-tab-allow-popups';
